<template>
  <div class="col-12">
    <div class="item-box">
      <div class="box-header bb-1">
        <h1 class="fs-12 fc-3">Maçın Kritik Adamları</h1>
        <div class="slider-dots text-center float-right mt-20">
          <span :class="index == pageIndex ? 'active' : ''" v-for="(i, index) in data" :key="index"></span>
        </div>
      </div>
      <div class="box-body pb-0">
        <carousel @pageChange="pageChanged" :perPage="1" :paginationEnabled="false">
          <slide v-for="(item, index) in data" :key="item.slug + '_' + index">
            <div class="player">
              <div class="row" style="margin: 0">
                <div class="col-3 p-0">
                  <div class="player-image">
                    <img
                      :src="item.photo != undefined ? item.photo : $store.state.baseImageURL + '/img/player/' + $store.state.app.yearslug + '/' + item.jerseyNo + '/face.webp' "
                      class="w-100"
                    />
                  </div>
                </div>
                <div class="col-9">
                  <h1 class="player-title fs-12 fc-6 pt-2">{{item.playerName || item.name}}</h1>
                  <div class="row">
                    <div class="col-4" v-for="stat in item.stats">
                      <h1 class="fs-12 fc-3">{{stat.title}}</h1>
                      <h2 class="fs-24 fc-1">{{stat.value}}</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </slide>
        </carousel>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Mvp",
  props: ["hideFloat", "hideLeader", "title", "data"],
  data() {
    return {
      pageIndex: 0
    };
  },
  methods: {
    pageChanged(index) {
      this.pageIndex = index;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Mvp.vue